// extracted by mini-css-extract-plugin
export default {"cls1":"siaoRwSTsPYWWSzhN7B1","cls2":"opeMO9L6CdmvjRw1T8rL siaoRwSTsPYWWSzhN7B1","animated":"VIthgUPgRQfVAx6zXmmO"};